







































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { cloneDeep } from 'lodash';

import {
	OrgPaymentMethod,
	OrgPaymentMethodResponse,
	formatPaymentMethod,
	PaymentType,
	formatAccountNumber,
} from '@/models/org-payment-method';
import { OrdwayService } from '@/services/ordway-service';

import EditPaymentMethod from './EditPaymentMethod.vue';
import AddPaymentMethod from './AddPaymentMethod.vue';

@Component({
	components: {
		EditPaymentMethod,
		AddPaymentMethod,
	},
})
export default class BillingTab extends Vue {
	get isBillingAdmin() {
		return this.$auth.user().billing;
	}
	public orgPaymentMethods: OrgPaymentMethod[] = [];
	public paymentMethodDisplayFields: Array<{
		key: string;
		label: string;
		formatter?: (value: any) => string;
	}> = [
		{
			key: 'type',
			label: 'Type',
			formatter: (type: string) => formatPaymentMethod(type as PaymentType),
		},
		{ key: 'accountName', label: 'Account Name' },
		{
			key: 'accountNumber',
			label: 'Account Number',
			formatter: (accountNumber: string) => formatAccountNumber(accountNumber),
		},
		{
			key: 'approved',
			label: 'Approved',
			formatter: (isApproved: boolean) => this.formatBooleanField(isApproved),
		},
		{
			key: 'active',
			label: 'Active',
			formatter: (isActive: boolean) => this.formatBooleanField(isActive),
		},
	];
	public selectedPaymentMethod: OrgPaymentMethod | null = null;
	@Prop({ type: Number, default: null }) private orgId!: number; // Can just access route params here.

	public created(): void {
		if (this.orgId !== null) {
			this.fetchPaymentMethods();
		}
	}

	public openEditModal(selectedPaymentMethod: OrgPaymentMethod): void {
		if (!this.isBillingAdmin) {
			return;
		}
		this.selectedPaymentMethod = cloneDeep<OrgPaymentMethod>(selectedPaymentMethod); // Don't want to mutate original payment method - pass a deep clone
		this.$bvModal.show('editPaymentMethod');
	}

	public openAddModal(): void {
		// Create a list of payment methods that the org is not subscribed to.
		this.$bvModal.show('addPaymentMethod');
	}

	public fetchPaymentMethods(): void {
		OrdwayService.fetchPaymentMethodsForOrg(this.orgId).then(
			(paymentMethods: AxiosResponse<OrgPaymentMethodResponse>) =>
				(this.orgPaymentMethods = paymentMethods.data.data),
		);
	}

	private formatBooleanField(value: boolean): 'Yes' | 'No' {
		return value === true ? 'Yes' : 'No';
	}
}
